// navigation-view.js

import $ from 'jquery';
import _ from 'lodash';
import constants from 'Constants.js';
import propertyViewMapService from 'PropertyViewMapService.js';

import { View } from 'backbone';

import contentTemplate from 'properties/navigation-view.ejs';


class NavigationView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = '#propNav';
        this.factoryKey = opts.factoryKey;

        if (this.factoryKey === undefined) {
            this.factoryKey = this.model.attributes.factoryKey;
        }
        return this;
    }

    render() {
        
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        // Render Property Views
        const views = propertyViewMapService.getNavigationViews(this.factoryKey);
        if (views) {
            views.map( v => {
                var obj = new v.view({model: this.model, el: $(v.el) });
                obj.render();
            });
        }

        return this;
    }

}

export default NavigationView;
